import { useTransition } from '../context/TransitionContext';

const TransitionOverlay = () => {
  const { progress, path1Ref, path2Ref, overlayRef, PATH_1_D, PATH_2_D } = useTransition();

  return (
    <>
      {/* Top progress bar - instant visual feedback during navigation */}
      {progress > 0 && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '2px',
            width: `${progress}%`,
            background: 'linear-gradient(to right, #3b82f6, #6366f1)',
            boxShadow: '0 0 8px rgba(59, 130, 246, 0.5)',
            zIndex: 9998,
            transition: 'width 0.18s ease-out, opacity 0.18s ease-out',
            opacity: progress > 0 && progress < 100 ? 1 : 0,
            pointerEvents: 'none',
          }}
        />
      )}

      {/* SVG Transition Overlay - codegrid style */}
      <div
        ref={overlayRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999,
          pointerEvents: 'none',
          display: 'none',
        }}
      >
        {/* Inner container scaled like codegrid .transition-svg */}
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '100%',
            height: '100%',
            transform: 'translate(-50%, -50%) scale(1.5)',
            pointerEvents: 'none',
          }}
        >
          <svg
            viewBox="0 0 2453 2535"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '100%', overflow: 'visible' }}
          >
            {/* Path 1 - Purple */}
            <path
              ref={path1Ref}
              d={PATH_1_D}
              stroke="#673df2"
              strokeWidth="200"
              strokeLinecap="round"
              fill="none"
            />
            {/* Path 2 - Charcoal */}
            <path
              ref={path2Ref}
              d={PATH_2_D}
              stroke="#171412"
              strokeWidth="200"
              strokeLinecap="round"
              fill="none"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default TransitionOverlay;
